import { useContext, useState } from "react";
import { styled } from "styled-components";
import Context from "../../Context.js";
import MaterialInput from "./MaterialInput.js";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
`;

const Item = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  color: var(--element);
  background: var(--surface2);
  border: 1px solid var(--border);
  box-shadow: var(--lightShadow);
  font-weight: 700;
  border-radius: 10px;

  &:hover {
    background: var(--accent);
    color: var(--mainBackground);
  }

  ${({ isActive }) => {
    if (isActive)
      return `
        background: var(--element);
        color: var(--elementAlt);
    `;
  }}
`;

export default function PopupSelect({
  value,
  options,
  onChange,
  isLinkBased,
  disableSearch,
}) {
  const [query, setQuery] = useState("");
  const { setForm } = useContext(Context);
  const { t } = useTranslation();

  return (
    <Container>
      {disableSearch ? null : (
        <MaterialInput
          autoFocus={true}
          onChange={({ target }) => {
            setQuery(target.value);
          }}
          label={"Chercher par mot clé"}
        />
      )}

      <List>{renderList()}</List>
    </Container>
  );

  function renderList() {
    let items = [];

    for (let i = 0; i < options.length; i++) {
      const item = options[i] || {};
      const label = (item.label ?? item.value ?? "").toString();
      if (query) {
        let theQuery = query;
        theQuery = theQuery.toString();
        let toMatch = label.toLowerCase();
        if (toMatch.indexOf(theQuery.toLowerCase()) === -1) {
          continue;
        }
      }
      items.push(
        <Item
          key={item.value ?? label ?? i}
          isActive={value == item.value}
          onClick={() => {
            if (!isLinkBased) setForm(null);
            onChange(item.value);
          }}
        >
          {label}
        </Item>
      );
    }

    return items;
  }
}
